//Vue使用QRCode插件，生成二维码
import QRCode from 'qrcode';

export default {
    name: "index",
    components: {},
    data() {
        return {
            platformAccountReference: undefined,
            channel: undefined,
            isMobileRemarkCompact: false,
            amount: undefined,
            accountNumber: undefined,
            vaName: undefined,
            bankName: undefined,
            qrUrl: undefined,
            logoList: [
                require("@/assets/old/napas.png"),
                require("@/assets/old/momo.png"),
                require("@/assets/old/zalopay.png"),
                require("@/assets/old/viettel.png"),
            ],
            isMobile: true,
        };
    },
    computed: {
        isQrOnlyMode() {
            return this.$route.query.isQrOnly == '1';
        },
        remark() {
            return this.channel === 'cardpay' && this.platformAccountReference
                ? this.platformAccountReference
                : '';
        }
    },
    methods: {
        downloadImage(imageUrl) {
            console.log("imageUrl",imageUrl)
            const name = Date.now() + ".png";
            const image = new Image()
            // 解决跨域 Canvas 污染问题
            image.setAttribute('crossOrigin', 'anonymous')
            image.onload = () => {
                const canvas = document.createElement('canvas')
                canvas.width = image.width
                canvas.height = image.height
                const context = canvas.getContext('2d')
                context.drawImage(image, 0, 0, image.width, image.height)
                canvas.toBlob((blob) => {
                    const url = URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.download = name || 'photo'
                    a.href = url
                    a.click()
                    a.remove()
                    URL.revokeObjectURL(url)
                })
            }
            image.src = imageUrl
        },
        download(href, name) {
            let eleLink = document.createElement('a')
            eleLink.download = name
            eleLink.href = href
            eleLink.click()
            eleLink.remove()
        },
        onCopy(str) {
            let url = str;
            let oInput = document.createElement("input");
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            console.log(oInput.value);
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$toast("Sao chép thành công!");
            oInput.remove();
        },
        formatNumber(num) {
            if(!num) return "";
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        textToQRCode(str){
            return new Promise((resolve) => {
                QRCode.toDataURL(
                    str,
                    {
                        margin: 1.8, // 留白为空
                    }
                ).then((url) => {
                    resolve(url);
                })
            })
        },
        async init(params) {
            const [amount, accountNumber, vaName, bankName] = params.split("_")
            const {qrText} = this.$route.query;
            if(qrText){
                this.qrUrl = await this.textToQRCode(qrText)
            }else{
                this.qrUrl = `https://vnqr.ngwepay.com/images/VimassQR/services/VMQR/getImage?id=qr_1_${accountNumber}_${amount}`;
            }

            // this.qrUrl = `https://vnqr.weiyiltd.xyz/images/VimassQR/services/VMQR/getImage?id=qr_1_${accountNumber}_${amount}`;
            // this.qrUrl = `http://115.146.122.124:2107/VimassQR/services/VMQR/getImage?id=qr_1_${accountNumber}_${amount}`;

            this.amount = amount === "{amount}" ? "" : amount;
            this.accountNumber = accountNumber;
            this.vaName = vaName;
            this.bankName = bankName;
        },
        getAppVa(){

            let that = this;
            this.isPending = true;
            that.$http.appVa(this.platformAccountReference).then((res) => {
                console.log("checkoutTransactions", res.data.transactionData.paymentStatus);
                // if(Date.now() > 1){
                //   that.isPending = false;
                //   that.isOver = true;
                //   return
                // }
                if (res.data.transactionData.paymentStatus == "PAID") {
                    // that.$toast("Successful repayment!!", 2000);

                    if (res.data.paymentData.redirectUrl) {
                        setTimeout(() => {
                            window.location.href = res.data.paymentData.redirectUrl;
                        }, 2000);
                        return;
                    }

                    that.isPending = false;
                    that.isOver = true;
                    clearInterval(that.setIntervalID);
                    // setTimeout(() => {
                    //   that.back();
                    // }, 2000);
                } else if (
                    res.data.transactionData.paymentStatus == "FAILED" ||
                    res.data.transactionData.paymentStatus == "EXPIRED"
                ) {
                    clearInterval(that.setIntervalID);
                    this.$emit("expired");
                }
            });
            that.setIntervalID = setInterval(() => {
                that.$http.appVa(this.platformAccountReference).then((res) => {
                        console.log("checkoutTransactions", res.data.transactionData.paymentStatus);
                        // if(Date.now() > 1){
                        //   that.isPending = false;
                        //   that.isOver = true;
                        //   clearInterval(setIntervalID);
                        //   return
                        // }
                        if (res.data.transactionData.paymentStatus == "PAID") {
                            // that.$toast("Successful repayment!!", 2000);

                            if (res.data.paymentData.redirectUrl) {
                                setTimeout(() => {
                                    window.location.href = res.data.paymentData.redirectUrl;
                                }, 2000);
                                return;
                            }

                            that.isPending = false;
                            that.isOver = true;
                            // setTimeout(() => {
                            //   that.back();
                            // }, 2000);
                            clearInterval(that.setIntervalID);
                        } else if (
                            res.data.transactionData.paymentStatus == "FAILED" ||
                            res.data.transactionData.paymentStatus == "EXPIRED"
                        ) {
                            clearInterval(that.setIntervalID);
                            this.$emit("expired");
                        }
                    });

                // .catch((err)=>{
                //     that.isPending = false;
                //     that.$toast("System is abnormal, Please try again.", 2000);
                //     clearInterval(setIntervalID);
                // });
            }, 3000);

            // setTimeout(() => {
            //   that.isPending = false;
            //   that.$toast("System is abnormal, Please try again.", 2000);
            //   clearInterval(setIntervalID);
            // }, 60000);



        },
        refreshData() {
            if (this.$route.query.params) {
                this.init(this.$route.query.params);
                this.platformAccountReference = this.$route.query.platformAccountReference;
                this.channel = this.$route.query.channel;
                this.getAppVa();
            }
        },
        updateMobileRemarkLayout() {
            if (!this.isMobile || !this.remark || !this.$el) {
                this.isMobileRemarkCompact = false;
                return;
            }

            this.isMobileRemarkCompact = this.$el.scrollHeight > window.innerHeight;
        },
        initRem() {
            const baseSize = 16
            this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            const size = this.isMobile ? 375 : 1620;

            function setRem() {
                const scale = document.documentElement.clientWidth / size
                document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
            }

            setRem()
            window.onresize = function () {
                setRem()
            }

        }
    },
    created() {
        this.initRem();

        this.refreshData();
    },
    mounted() {
        this.$nextTick(() => {
            this.updateMobileRemarkLayout();
        });
        window.addEventListener('resize', this.updateMobileRemarkLayout);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateMobileRemarkLayout);
    },
};
